module.exports = __webpack_public_path__ + "img/symbol_2.ef440a1c.png";